import { Controller } from 'stimulus'

export default class extends Controller {

  initialize() {
    if (document.querySelector('a[href$=mp3]')) {
      let body = document.querySelector('body')
      let player_html = '<audio id="audio-player" src="">Your browser does not support the <code>audio</code> element.</audio>'
      body.insertAdjacentHTML('beforeend', player_html)

      this.player = document.getElementById('audio-player')

      var self = this

      document.addEventListener('click', function(event) {
        if (event.target.href && event.target.href.match(/\.mp3$/)) {
          event.preventDefault()

          if (event.target.classList.contains('play')) {
            event.target.classList.remove('play')
            self.stop()
          } else {
            if (document.querySelector('a[href$=mp3].play')) {
              document.querySelector('a[href$=mp3].play').classList.remove('play')
            }

            event.target.classList.add('play')
            self.play(event.target.href)
          }
        }
      })
    }
  }

  play(audio) {
    this.player.src = audio
    this.player.play()
  }

  stop() {
    this.player.pause()
  }
}
